// eslint-disable-next-line no-shadow
enum CommunicationStatus {
  AWAITING,
  PROCESSING,
  PROCESSED,
  ERROR,
}
export default CommunicationStatus;
